export const siteInfo = {
  name: "美女网站精选推荐",
  tagline: "高颜值内容聚合平台",
  description:
    "专业的美女网站导航与内容聚合平台，精选全网高质量美女写真、时尚穿搭、美妆教程与生活方式内容。每日更新，严格筛选，为爱美人士提供最优质的视觉体验与时尚资讯。",
  url: "https://meinvwangzhan.com",
  logo: "",
  foundingYear: "2020",
  email: "contact@meinvwangzhan.com",
  phone: "400-888-6666",
  address: "上海市浦东新区陆家嘴金融贸易区世纪大道100号",
  social: {
    weibo: "https://weibo.com/meinvwangzhan",
    wechat: "meinvwangzhan",
    xiaohongshu: "https://xiaohongshu.com/meinvwangzhan",
  },
  stats: {
    articles: 580,
    categories: 6,
    totalViews: "1,280万",
    subscribers: "38万",
  },
  faqs: [
    {
      question: "本站的内容来源是什么？",
      answer: "本站内容由专业编辑团队精心筛选，来源包括优质时尚博主、专业摄影师作品、美妆达人分享等。所有内容均经过严格审核，确保质量和原创性。",
    },
    {
      question: "内容更新频率是怎样的？",
      answer: "我们坚持每日更新，每天至少发布5-10篇精选内容。周末和节假日也会有特别策划的专题内容上线，确保用户每天都能看到新鲜内容。",
    },
    {
      question: "如何推荐优质的博主或内容给我们？",
      answer: "您可以通过联系我们页面提交推荐信息，或者发送邮件至 contact@meinvwangzhan.com。我们的编辑团队会认真审核每一条推荐。",
    },
    {
      question: "可以在手机上浏览本站吗？",
      answer: "当然可以！本站采用响应式设计，在手机、平板、电脑上都有良好的浏览体验。您随时随地方便浏览精彩内容。",
    },
    {
      question: "本站的内容可以转载吗？",
      answer: "本站原创内容受版权保护，如需转载请联系我们获取授权。转载时需注明出处并保留原文链接。未经授权擅自转载将追究法律责任。",
    },
  ],
  testimonials: [
    {
      name: "小雨",
      role: "时尚博主",
      content: "在这个平台找到了很多灵感，内容质量很高，每天必看的网站之一！",
      rating: 5,
    },
    {
      name: "Lisa Chen",
      role: "美妆达人",
      content: "分类非常清晰，找内容很方便。尤其是美妆教程板块，干货满满！",
      rating: 5,
    },
    {
      name: "小王同学",
      role: "摄影爱好者",
      content: "写真图集的质量真的很棒，每天都有新惊喜。推荐给了很多朋友。",
      rating: 5,
    },
    {
      name: "张美丽",
      role: "大学生",
      content: "时尚穿搭板块是我最常逛的，很多搭配灵感都来自这里，超实用！",
      rating: 4,
    },
    {
      name: "Rainie",
      role: "职场白领",
      content: "生活方式板块的内容让我的生活质量提升了不少，健身和美食内容都很赞。",
      rating: 5,
    },
    {
      name: "阿杰",
      role: "自媒体运营",
      content: "博主推荐板块帮我发现了很多宝藏创作者，对内容创作很有启发。",
      rating: 5,
    },
  ],
};